<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
    <!-- MainView -->
    <profile-items :userIcon="getUserIcon"
                  :userName="getUserName"
                  :userDept="getUserDept"
                  :userFeeling="getUserFeeling"
                  :userEmail="getUserEmail"
                  :userPhone="getUserPhone"
                  :careerSummary="getUserCareerSummary"
                  :userBio="getUserBio"
                  :rUserBio="replaceUserBio"
                  :edit="this.edit"
                  :vName="this.vName"
                  v-on:set-profileItems="updateProfileItems"
                  v-on:start-edit="startEdit"
                  v-on:check-name="checkNameValidation"
                  v-on:cancel-profileEdit="cancelEdit"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CommonJs from '@/js/common'
import { validationMixin } from 'vuelidate'
import ProfileItems from '@/components/User/ProfileItems'

function byte (str) {
  var length = 0
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i)
    if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
      length += 1
    } else {
      length += 2
    }
  }
  return length
}
function nameValidation () {
  if (this.editInfo.userName.trim().length === 0) {
    return false
  } else {
    return true
  }
}
function nameLengthValidation () {
  if (byte(this.editInfo.userName) > 24) {
    return false
  } else {
    return true
  }
}

function deptLengthValidation () {
  if (byte(this.editInfo.dept) > 40) {
    return false
  } else {
    return true
  }
}

function bioLengthValidation () {
  if (byte(this.editInfo.userBio) > 100) {
    return false
  } else {
    return true
  }
}

function phoneValidation () {
  var validate = true
  var regexp = /^\+?(?:[0-9]?){6,14}[0-9]$/
  if (!this.editInfo.userPhone.match(regexp) && this.editInfo.userPhone) {
    validate = false
    return false
  }
  if (validate) {
    return true
  }
}

export default {
  name: 'Profile',
  mixins: [CommonJs],
  mixedins: [validationMixin],
  components: {
    ProfileItems
  },
  data: function () {
    return {
      tag: 'progress',
      edit: false,
      vName: true,
      editInfo: {
        userName: '',
        dept: '',
        userFeeling: '',
        userBio: '',
        userEmail: '',
        userPhone: '',
        careerSummary: ''
      }
    }
  },
  validations: {
    editInfo: {
      userName: {
        nameValidation,
        nameLengthValidation
        // required
      },
      dept: {
        deptLengthValidation
      },
      userBio: {
        bioLengthValidation
      },
      userPhone: {
        phoneValidation
      }
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'Profile'
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser',
      'getCurrentUserInfo'
    ]),
    getUserName: function () {
      if (this.getCurrentUserInfo && this.getCurrentUserInfo.userName) return this.getCurrentUserInfo.userName
      else return ''
    },
    getUserIcon: function () {
      if (this.getCurrentUserInfo && this.getCurrentUserInfo.userIcon) return this.getCurrentUserInfo.userIcon
      else return ''
    },
    getUserDept: function () {
      if (this.getCurrentUserInfo && this.getCurrentUserInfo.dept) return this.getCurrentUserInfo.dept
      else return ''
    },
    getUserFeeling: function () {
      if (this.getCurrentUserInfo && this.getCurrentUserInfo.userFeeling) return this.getCurrentUserInfo.userFeeling
      else return ''
    },
    getUserBio: function () {
      if (this.getCurrentUserInfo && this.getCurrentUserInfo.userBio) return this.getCurrentUserInfo.userBio
      else return ''
    },
    replaceUserBio: function () {
      if (this.getCurrentUserInfo && this.getCurrentUserInfo.userBio) {
        var valContainer = this.getCurrentUserInfo.userBio
        let stringArray = []
        let contentText = valContainer.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/`/g, '&#x60;')
        stringArray = contentText.split(/\r?\n/g)
        let resultContent = stringArray.join('<br>')
        return resultContent
        // return this.getCurrentUserInfo.userBio
      } else {
        return ''
      }
    },
    getUserEmail: function () {
      if (this.getCurrentUserInfo && this.getCurrentUserInfo.userEmail) return this.getCurrentUserInfo.userEmail
      else return ''
    },
    getUserPhone: function () {
      if (this.getCurrentUserInfo && this.getCurrentUserInfo.userPhone) return this.getCurrentUserInfo.userPhone
      else return ''
    },
    getUserCareerSummary: function () {
      if (this.getCurrentUserInfo && this.getCurrentUserInfo.careerSummary) return this.getCurrentUserInfo.careerSummary
      else return ''
    }
  },
  mounted: function () {
    this.setEdittingProfileFalse()
  },
  methods: {
    ...mapActions('profiles/', {
      setProfile: 'SET_PROFILE',
      setFeeling: 'SET_FEELING'
    }),
    ...mapActions('repository/', {
      setEdittingProfileTrue: 'setEdittingProfileTrue',
      setEdittingProfileFalse: 'setEdittingProfileFalse'
    }),
    startEdit: function () {
      this.edit = !this.edit
      this.setEdittingProfileTrue()
    },
    updateFeeling: function (value) {
      // コンディションの変更
      if (this.edit) {
        this.editInfo.userFeeling = value
      } else {
        this.setFeeling(value)
      }
    },
    updateProfileItems: function (value) {
      this.editInfo = value
      const $t = this.$t
      if (!this.$v.editInfo.userName.nameValidation) {
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          text: $t('noUserNameStr'),
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        }).then((result) => {
          if (result.value) {
            console.log('true')
          } else {
            console.log('false')
          }
        })
      } else if (!this.$v.editInfo.userName.nameLengthValidation) {
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          text: $t('warningUserNameStr'),
          showCancelButton: false,
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        }).then((result) => {
          if (result.value) {
            console.log('true')
          } else {
            console.log('false')
          }
        })
      } else if (this.editInfo.dept && !this.$v.editInfo.dept.deptLengthValidation) {
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          text: $t('warningdepartmentStr'),
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        }).then((result) => {
          if (result.value) {
            console.log('true')
          } else {
            console.log('false')
          }
        })
      } else if (this.editInfo.userBio && !this.$v.editInfo.userBio.bioLengthValidation) {
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          text: $t('warningCommentStr'),
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 4000
        }).then((result) => {
          if (result.value) {
            console.log('true')
          } else {
            console.log('false')
          }
        })
      // } else if (!this.$v.editInfo.userBio.bioLengthValidation) {
      //   this.$swal({
      //     // sweetAlartの処理
      //     title: $t('popTitleStrType'),
      //     text: $t('warningCommentStr'),
      //     type: 'warning',
      //     confirmButtonClass: 'btn btn-success'
      //   }).then((result) => {
      //     if (result.value) {
      //       console.log('true')
      //     } else {
      //       console.log('false')
      //     }
      //   })
      } else if (this.editInfo.userPhone && !this.$v.editInfo.userPhone.phoneValidation) {
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          text: $t('notTellNumberStr'),
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        }).then((result) => {
          if (result.value) {
            console.log('true')
          } else {
            console.log('false')
          }
        })
      } else {
        if (this.editInfo.userIcon === '') {
          delete this.editInfo.userIcon
        }
        this.setProfile(this.editInfo)
        this.setEdittingProfileFalse()
        this.edit = !this.edit
      }
    },
    checkNameValidation (value) {
      if (value.trim().length === 0 || byte(value) > 24) {
        this.vName = false
      } else {
        this.vName = true
      }
    },
    cancelEdit () {
      const $t = this.$t
      this.$swal({
        // sweetAlartの処理
        title: $t('popTitleStrType'),
        text: $t('confirmInputDeleteStr'),
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        type: 'warning',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        reverseButtons: false,
        animation: false,
        customClass: 'animated fadeInUp',
        width: '35rem',
        position: 'center',
        allowOutsideClick: false,
        padding: '2rem'
      }).then((result) => {
        if (result.value) {
          this.edit = !this.edit
          this.setEdittingProfileFalse()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/Profile.vue